import api from '../api'

export const myAppResource = {
  all () {
    return api().get('/GetUserApplications')
  },

  find (id) {
    return api().get(`/GetApplicationInstance/${id}`)
  },

  create (payload) {
    return api().post('/CreateApplicationInstance', payload)
  },

  update (id, payload) {
    return api().post(`/UpdateApplicationInstance/${id}`, payload)
  },

  destroy (id) {
    return api().post(`/DeleteApplicationInstance/${id}`)
  },

  createProperty (id, propertyValue) {
    return api().post('/CreateApplicationInstance', { applicationInstanceId: id, propertyValue: propertyValue })
  },

  updateProperty (id, propertyValue) {
    return api().post('/UpdateApplicationInstance', { applicationInstanceId: id, propertyValue: propertyValue })
  },
}
